.buttonContainer {
  line-height: 0;
  margin-top: var(--space-medium);
}

.noMargin {
  margin-top: 0;
}

.buttonContainer > div > * {
  margin: 0 var(--space-small);
}

.buttonContainer > div > *:first-child {
  margin-left: 0;
}

.buttonContainer > div > *:last-child {
  margin-right: 0;
}

.buttonContainer.right {
  text-align: right;
}

.buttonContainer.center {
  text-align: center;
}
